import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    jobs : {}
}

const jobSlice = createSlice({

    name:"jobs",
    initialState,
    reducers : {
        addJobs : (state, {payload}) => {
            state.jobs = payload
        },
    }
});

export const {addJobs} = jobSlice.actions;
export const getJobs = (state) => state.jobs.jobs;
export default jobSlice.reducer;
